module.exports = __webpack_public_path__ + "img/C9.c09970b9.webp";